import debounce from "lodash.debounce";
import React, { useCallback, useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { gstVerificationRequest } from "../../store/actions";

export default function UserTable({ columns, rows, setRows, OLDDataList, setOLDDataList, onChangesAuctionCenterId, disabled }) {
    const [checkedColumns, setCheckedColumns] = useState({});
    const [oldColumnValues, setOldColumnValues] = useState({});
    const dispatch = useDispatch()
    const handleInputChange = (event, rowId, fieldName) => {
        const newValue = event.target.value;

        if (checkedColumns[fieldName]) {
            // If the column is checked, update all cells in the column with the new value
            setRows(prevData =>
                prevData?.map(row => ({ ...row, [fieldName]: newValue }))
            );
        } else {
            // Otherwise, update only the specific cell
            setRows(prevData =>
                prevData?.map((row, idx) =>
                    row.auctionCenterId === rowId ? { ...row, [fieldName]: newValue } : row
                )
            );
        }

        // Always update the OLDDataList
        setOLDDataList(prevData =>
            prevData?.map((row, idx) =>
                idx === rowId ? { ...row, [fieldName]: newValue } : row
            )
        );
    };
    const debouncedApiCall = useCallback(
        debounce((stateId, key, value) => {
            console.log(value)
            // dispatch(gstVerificationRequest(value));
        }, 2000),
        [] // Dependency array to ensure the function is only created once
    );
    const tempAuctionCenterDataChange = (
        key,
        value,
        stateId,
        fromMultiple,
        debouncedApiCall
    ) => {
        // if (fromMultiple) {
        let data =
            rows &&
            rows.map((data, index) => {
                if (data.stateId === stateId) {
                    data[key] = value;
                }
                return data;
            });

        // handleCheckboxChange(e, index, name)
        setRows(data);


        if (key === "gstNo") {
            console.log(stateId, key, value, "stateId, key, value");
            debouncedApiCall(stateId, key, value);
        }
    };

    const handleCheckboxChange = (isChecked, fieldName) => {
        setCheckedColumns(prev => ({ ...prev, [fieldName]: isChecked }));

        if (isChecked) {
            // Save the current values of the column and mark them as disabled
            const currentColumnValues = rows.map(row => row[fieldName]);
            setOldColumnValues(prev => ({ ...prev, [fieldName]: currentColumnValues }));

            // Set all cells in the column to the first cell's value
            const firstCellValue = rows[0][fieldName];
            setRows(prevData =>
                prevData?.map(row => ({ ...row, [fieldName]: firstCellValue }))
            );
        } else {
            // Revert only the values in the column that were changed when the column was checked
            setRows(prevData =>
                prevData?.map((row, idx) => {
                    if (checkedColumns[fieldName] && idx !== 0) {
                        return { ...row, [fieldName]: oldColumnValues[fieldName][idx] };
                    }
                    return row;
                })
            );
        }
    };

    return (
        <div className="col-12">
            <div className="TableBox w-100">
                {onChangesAuctionCenterId?.length > 0 && <Table striped bordered hover responsive>
                    <thead>
                        <tr>
                            {columns?.map((ele, colIndex) => (
                                <th key={colIndex} className={ele.mandatory ? 'mandatory-field' : ''}>
                                    {ele.title}
                                    {ele.checkbox && (
                                        <input
                                            type="checkbox"
                                            onChange={(e) => handleCheckboxChange(e.target.checked, ele.name)}
                                            disabled={disabled}

                                        />
                                    )}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {rows?.filter(ele => onChangesAuctionCenterId?.includes(ele.auctionCenterName))?.map((ele, index) => ({ ...ele, srNo: index + 1 })).map((item, index) => (
                            <tr key={index}>
                                {columns?.map((ele, colIndex) => (
                                    <td key={colIndex}>
                                        {ele.noneditable ? (
                                            ele.fixValue ? ele.fixedColumnValue : item[ele.name]
                                        ) : ele.dropdown ? (
                                            <select
                                                value={item[ele.name] ?? ""}
                                                onChange={(event) => handleInputChange(event, item.auctionCenterId, ele.name)}
                                                disabled={disabled ? disabled : checkedColumns[ele.name] && index !== 0}
                                            >
                                                <option value={0}>Please Select</option>
                                                {ele?.options?.map((option, optIndex) => (
                                                    <option key={optIndex} value={option.value}>
                                                        {option.title}
                                                    </option>
                                                ))}
                                            </select>
                                        ) : ele.name === "bankAccountStatus" ?
                                            item[ele.name] === 1 ? "ACTIVE" : "INACTIVE"  
                                            : ele.name === "gstNo" ?
                                                (
                                                    <input
                                                        type="text"
                                                        maxLength="15"
                                                        value={item[ele.name] ?? ""}
                                                        onChange={(e) => {
                                                            tempAuctionCenterDataChange(
                                                                "gstNo",
                                                                e.target.value,
                                                                "",
                                                                false,
                                                                debouncedApiCall
                                                            )
                                                            handleInputChange(e, item.auctionCenterId, ele.name)
                                                        }
                                                        }
                                                        disabled={disabled}
                                                    />)
                                                : ele.name === "mobileNo" ? (
                                                    <input
                                                        type="text"
                                                        maxLength={ele.maxLength}
                                                        value={item[ele.name] ?? ""}
                                                        onChange={(event) => handleInputChange(event, item.auctionCenterId, ele.name)}
                                                        disabled={disabled ? disabled : checkedColumns[ele.name] && index !== 0}
                                                    />
                                                ) : (
                                                    <input
                                                        type="text"
                                                        value={item[ele.name] ?? ""}
                                                        onChange={(event) => handleInputChange(event, item.auctionCenterId, ele.name)}
                                                        disabled={disabled ? disabled : checkedColumns[ele.name] && index !== 0}
                                                    />
                                                )}
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </Table>}

            </div>
        </div>
    );
}
